module.exports = "//static.hsappstatic.net/LoginUI/static-1.13288/img/connect.com-full-logo-color.svg"